import React from 'react'
import Svg from 'src/Components/shared/Svg'

const BotLogo = () => {
  return (
    <Svg viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0)'>
        <path
          d='M55.8 28.5C55.8 43.5 43.6 55.7 28.6 55.7C13.6 55.7 1.20001 43.5 1.20001 28.5C1.20001 13.5 13.5 1.19995 28.5 1.19995C43.5 1.19995 55.8 13.5 55.8 28.5Z'
          stroke='#FC5AA6'
          strokeWidth='2.5'
        />
        <path
          d='M40.6 23.9C39.7 23.7 37.8 23.5 36.2 23.5C34.5 23.5 32.4 23.8 31.4 24C31.2 24.8 30.9 26.1 30.9 27.7C30.9 29.2 31.1 30.5 31.3 31.2C32.4 31.4 34.7 31.7 36.1 31.7C37.5 31.7 39.6 31.5 40.6 31.3C40.8 30.6 41 29.2 41.1 27.8V27.2C41 25.9 40.7 24.6 40.6 23.9ZM35.4 30.3C33.9 30.3 32.6 29.1 32.6 27.6C32.6 26.1 33.8 24.8 35.4 24.8C36.9 24.8 38.2 26 38.2 27.6C38.2 29.1 36.9 30.3 35.4 30.3Z'
          fill='white'
        />
        <path
          d='M16.3 22.1C17.1 21.9 19.3 21.6 21.3 21.6C23.3 21.6 25.7 22 26.6 22.1C27.2 22.2 27.7 22.7 27.9 23.3C28.1 24 28.3 25 28.4 26.3C28.6 26.3 28.9 26.3 29.1 26.3C29.2 25 29.5 23.9 29.6 23.3C29.8 22.7 30.3 22.2 30.9 22.1C31.8 21.9 34.3 21.6 36.2 21.6C38.1 21.6 40.2 21.9 41.1 22.1C41 20.8 39.9 19.9 38.6 19.9H29.2V18.4C31.1 18.1 32.6 16.4 32.6 14.5C32.6 12.3 30.8 10.5 28.6 10.5C26.4 10.5 24.6 12.3 24.6 14.5C24.6 16.4 26 18.1 27.8 18.4V19.9H18.5C17.1 19.9 16 21 16 22.3C16 22.2 16.1 22.1 16.3 22.1Z'
          fill='white'
        />
        <path
          d='M42.9 27.7999V28.5C42.9 29.3 42.9 29.5 42.8 30.2C42.7 30.9 42.5 31.4999 42.5 31.9C42.3 32.4999 41.8 32.9999 41.2 33.0999C40.2 33.1999 37.8 33.5 36.2 33.5C34.6 33.5 31.9 33.1 30.9 32.9C30.3 32.8 29.8 32.3 29.6 31.7C29.4 31.1 29.1 29.8 29.1 28.1L29 28C28.9 27.9 28.7 27.9 28.6 28L28.5 28.1C28.4 29.7 28.2 31 28 31.7C27.8 32.3 27.3 32.8 26.7 32.9C25.6 33.1 23 33.5 21.4 33.5C19.8 33.5 17.4 33.1999 16.4 33.0999C15.8 32.9999 15.2 32.4999 15.1 31.9C15 31.4999 14.9 30.9 14.8 30.2C14.7 29.6 14.7 29.1 14.7 28.5C14.7 28.3 14.7 28.1 14.7 27.9C14.7 27.8 14.7 27.8 14.7 27.7H14.5C13.7 27.7 13.1 28.3 13.1 29.1V34.5999C13.1 35.3999 13.7 36 14.5 36H16V40.2999C16 41.6999 17.1 42.7999 18.5 42.7999H22.8H38.7C40.1 42.7999 41.2 41.6999 41.2 40.2999V36H42.7C43.5 36 44.1 35.3999 44.1 34.5999V29.1C43.9 28.5 43.5 27.9999 42.9 27.7999ZM38.1 37.7C38.1 38.5 37.4 39.2999 36.5 39.2999H20.7C19.8 39.2999 19.1 38.6 19.1 37.7V37.5C19.1 36.7 19.8 35.9 20.7 35.9H36.5C37.4 35.9 38.1 36.6 38.1 37.5V37.7Z'
          fill='white'
        />
        <path
          d='M16.8 23.9C16.6 24.6 16.3 26.1 16.3 27.5C16.3 28.9 16.6 30.5 16.8 31.2C17.8 31.3 19.9 31.6 21.3 31.6C22.7 31.6 25 31.3 26.1 31.1C26.3 30.4 26.5 29.2 26.5 27.6C26.5 26 26.2 24.7 26 23.9C25 23.7 22.9 23.4 21.2 23.4C19.6 23.5 17.7 23.8 16.8 23.9ZM25 27.6C25 29.1 23.8 30.3 22.2 30.3C20.6 30.3 19.4 29.1 19.4 27.6C19.4 26.1 20.6 24.8 22.2 24.8C23.8 24.8 25 26.1 25 27.6Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='57' height='57' fill='white' />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default BotLogo
